import {ReactNode} from 'react'
import clsx from 'clsx'

type DivProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>

export interface DrawerBodyProps extends DivProps {
  children: ReactNode
}

export const DrawerBody = ({children, className, ...otherProps}: DrawerBodyProps) => {
  return (
    <div className={clsx('drawer-body', className)} {...otherProps}>
      {children}
    </div>
  )
}
